import interceptor from '@/plugins/interceptor';
const pathController = '/TrafficLogFile'

export default {
  state: () => ({
  }),
  getters: {
  },
  mutations: {
  },
  actions: {
    async trafficLogFile_get({ dispatch }, { stationId, date }) {
      try {
        const request = await interceptor.authenticate.get(`${process.env.VUE_APP_API_URL}${pathController}/getTrafficLog?stationId=${stationId}&date=${date}`);
        return { ok: true, data: request.data };
      } catch (error) {
        if (error.response && error.response.status === 404) {
          return { ok: true, data: null };
        }
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${window.vueApp.$t('workspace.log_editor.load_error')}`, title: window.vueApp.$t('left_menu.spot_programming.log_editor'), error: true});
        return { ok: false, data: null };
      }
    }
  }
}
